import { render, staticRenderFns } from "./BookProductItem.vue?vue&type=template&id=2fbcd2e8&"
import script from "./BookProductItem.vue?vue&type=script&lang=js&"
export * from "./BookProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports